import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
// import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
// import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'


import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

import './index.scss'

import {AppRoutes} from './app/routing/AppRoutes'
// import {AuthProvider, setupAxios} from './app/modules/auth'
import {Provider} from 'react-redux'
import store from './store'
import {BrowserRouter} from 'react-router-dom'
import {StrictMode} from 'react'

// import { PrimeReactProvider } from 'primereact/api'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
const {PUBLIC_URL} = process.env

if (container) {
  createRoot(container).render(
    <StrictMode>
      <Provider store={store}>
        {/* <PrimeReactProvider> */}
            <QueryClientProvider client={queryClient}>
              <MetronicI18nProvider>
                {/* <AuthProvider> */}
                  <BrowserRouter basename={PUBLIC_URL}>
                    <AppRoutes />
                  </BrowserRouter>
                {/* </AuthProvider> */}
              </MetronicI18nProvider>
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </QueryClientProvider>
        {/* </PrimeReactProvider> */}
        
      </Provider>
    </StrictMode>
  )
}
